import React, { useState, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { toJS } from 'mobx';
import { HelperCore } from '@/common/dependencies';
import { request } from '@/common';
import chatStoreManager from '@/store/chat/manager';
import Loader from '@/common/helper/loader';
import { HelpOther } from '@/common/helper';

const numberToChinese = num => {
  var units = ['', '十', '百', '千', '万', '十万', '百万', '千万', '亿'];
  var digits = ['', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
  var result = '';

  var numArray = String(num).split('').reverse(); // 将数字转为倒序的数组
  for (var i = 0; i < numArray.length; i++) {
    var digit = numArray[i]; // 当前位的数字
    var unit = units[i]; // 当前位的单位

    // 对于0的处理
    if (digit === '0') {
      // 如果是连续的多个0，只保留一个零
      if (result[0] === '零') {
        result = result.substring(1);
      }
      // 如果不是最末尾的0，添加一个零
      if (i !== numArray.length - 1) {
        result = '零' + result;
      }
      continue;
    }

    result = digits[digit] + unit + result;
  }

  return result.replace('一十', '十').replace('十零', '十');
};

const requestAiagentPlan = (plan, requestPlanParams) => {
  return request.post(
    '/ai_agent/plan',
    {
      ...requestPlanParams,
      plan,
    },
    { dataIsJson: true }
  );
};

//设置光标
const setCursorPosition = (div, position) => {
  const textNode = div.childNodes[0];
  if (!textNode) {
    return;
  }
  const range = document.createRange();
  const sel = window.getSelection();
  range.setStart(textNode, position);
  range.setEnd(textNode, position);

  sel.removeAllRanges(); // 清除现有选区
  sel.addRange(range); // 添加新的选区
};

function add0(num) {
  return num > 9 ? num : '0' + num;
}
//简单处理二维数组
const modifyArray = (arr, index, subIndex, text) => {
  //text为空时就执行删除操作
  if (!text) {
    arr[index].sub_steps.splice(subIndex, 1);
  } else {
    arr[index].sub_steps[subIndex] = text;
  }
  return HelperCore.copyObj(
    arr.filter(item => item.sub_steps.filter(item => item).length)
  );
};

let isSave = false;
const TextItem = ({
  item,
  realIndex,
  index,
  parentIndex,
  disable,
  onDelete,
  onSave,
  listData,
  setListData,
  requestPlanParams,
  planStepId,
}) => {
  const [canEdit, setCanEdit] = useState(false);
  const [isFocus, setIsFocus] = useState(false);
  const editDivRef = useRef(null);
  return (
    <div
      key={index}
      className={['min-h-40px pl-34px flex items-center text-black text-14px']}
    >
      <div className="h-40px leading-40px self-start">{add0(realIndex)}.</div>
      <div
        className={[
          'flex items-center flex-grow w-0',
          'ml-2px pr-12px group-1 cursor-default',
          'rounded-8px hover:bg-[rgba(0,0,0,0.03)]',
        ]}
      >
        <div
          ref={editDivRef}
          suppressContentEditableWarning
          contentEditable={canEdit}
          onInput={evt => {
            const maxLength = 100;
            const div = evt.target;
            if (div.innerText.length > maxLength) {
              div.innerText = div.innerText.slice(0, maxLength);
              setCursorPosition(div, maxLength);
            }
          }}
          maxLength={10}
          onBlur={evt => {
            setTimeout(() => {
              setCanEdit(false);
              setIsFocus(false);
              if (!isSave) {
                evt.target.innerText = item;
              }
              isSave = false;
            }, 200);
          }}
          onFocus={evt => {
            setIsFocus(true);
          }}
          className={[
            'relative flex-grow w-0 py-9px px-10px mr-12px leading-20px border-1px border-transparent',
          ]}
        >
          {item}
        </div>
        <div
          className={[
            'flex h-40px leading-40px flex-shrink-0',
            isFocus ? '' : 'group-1-hover:visible invisible',
            disable ? 'opacity-30' : '',
          ]}
        >
          <div
            onClick={evt => {
              if (disable) return;
              setCanEdit(true);
              setTimeout(() => {
                editDivRef.current.focus();
                setCursorPosition(editDivRef.current, item.length);
              }, 20);
            }}
            className={[
              'text-black text-opacity-50 mr-16px',
              disable ? '' : 'hover:text-opacity-70 cursor-pointer',
            ]}
          >
            编辑
          </div>
          {isFocus ? (
            <div
              onClick={evt => {
                isSave = true;
                const text = editDivRef.current.innerText;
                const planList = modifyArray(
                  toJS(listData),
                  parentIndex,
                  index,
                  text
                );
                requestAiagentPlan(planList, requestPlanParams).then(res => {
                  setListData(planList);
                  chatStoreManager.updateToolsPlanEditData(planStepId, 'planList', planList);
                }).catch(res => {
                  editDivRef.current.innerText = item;
                  const planList = modifyArray(
                    toJS(listData),
                    parentIndex,
                    index,
                    item
                  );
                  setListData(planList);
                  chatStoreManager.updateToolsPlanEditData(planStepId, 'planList', planList);
                  if(res.code == '420100'){
                    HelpOther.toast('内容敏感，请重新编辑', 'error');
                  }
                })
                onSave && onSave(text);
              }}
              className={[
                'text-black',
                disable ? '' : 'cursor-pointer hover:text-[#333]',
              ]}
            >
              保存
            </div>
          ) : (
            <div
              onClick={evt => {
                if (disable) return;
                const planList = modifyArray(
                  toJS(listData),
                  parentIndex,
                  index,
                  ''
                );
                requestAiagentPlan(planList, requestPlanParams).then(res => {
                  setListData(planList);
                  chatStoreManager.updateToolsPlanEditData(planStepId, 'planList', planList);
                });
                onDelete && onDelete(item);
              }}
              className={[
                'text-[#FF3B30]',
                disable ? '' : 'hover:text-[#B6061A] cursor-pointer',
              ]}
            >
              删除
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const McpToolsPlan = observer(props => {
  const {
    className = '',
    planStepId,
    onRenew,
    onDelete,
    onSave,
    onExecute,
    planList,
    planed = false,
    requestPlanParams = {},
  } = props;
  const [listData, setListData] = useState(chatStoreManager.toolsPlanEditData[planStepId]?.planList || planList || []);
  const [disableBtn, setDisableBtn] = useState(chatStoreManager.toolsPlanEditData[planStepId]?.disableBtn || planed);

  let realIndex = 0;
  return (
    <div
      className={[
        'mcp-tools-plan',
        'px-20px py-16px rounded-12px my-12px',
        'border-1px border-black border-opacity-10',
        className,
      ]}
      data-id={planStepId}
      onClick={
        event => {
          event.stopPropagation();
        }
      }
    >
      <div className="">
        {(listData || []).map((_item, _index) => {
          //if(!_item || !_item?.sub_steps?.length) return;
          return (
            <div className="mb-8px last:mb-26px" key={_index}>
              <div className="h-40px flex items-center text-black text-16px font-bold mb-4px">
                {numberToChinese(_index + 1)}、{_item.step_title}
              </div>
              {_item.sub_steps?.map((item, index) => {
                if (!item) return null;
                realIndex++;
                return (
                  <TextItem
                    listData={listData}
                    setListData={setListData}
                    item={item}
                    key={index}
                    parentIndex={_index}
                    index={index}
                    realIndex={realIndex}
                    disable={disableBtn}
                    onDelete={onDelete}
                    onSave={onSave}
                    planStepId={planStepId}
                    requestPlanParams={requestPlanParams}
                  />
                );
              })}
            </div>
          );
        })}
      </div>
      <div className="flex">
        <div
          onClick={evt => {
            if (disableBtn) return;
            onRenew && onRenew();
          }}
          className={[
            'flex-1 h-36px rounded-12px vh-center text-14px font-bold text-black border-1px border-black',
            disableBtn
              ? 'opacity-30'
              : 'hover:bg-[rgba(0,0,0,0.03)] cursor-pointer',
          ]}
        >
          重新规划
        </div>
        <div
          onClick={evt => {
            if (disableBtn) return;
            onExecute && onExecute();
            setDisableBtn(true);
            chatStoreManager.updateToolsPlanEditData(planStepId, 'disableBtn', true);
          }}
          className={[
            'flex-1 h-36px rounded-12px vh-center text-14px font-bold text-white bg-black ml-12px',
            disableBtn ? 'opacity-30' : 'hover:bg-[#333] cursor-pointer',
          ]}
        >
          开始执行
        </div>
      </div>
    </div>
  );
});
export default McpToolsPlan;
